import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

export function useScreenPermission(screenName: string) {
  const { loaded, data } = useSelector((state: RootState) => state.permissions);
  const perm = data[screenName];

  return {
    loading:   !loaded,
    canView:   loaded ? (perm?.Can_View   ?? false) : true,
    canCreate: perm?.Can_Create ?? false,
    canUpdate: perm?.Can_Update ?? false,
    canDelete: perm?.Can_Delete ?? false,
  };
}
